import { ApiBase } from './ApiBase'

export class BulkJobsApi extends ApiBase {
  async generateReports(folderIds: string[], checklistIds: number[]) {
    return this.post('/bulk_jobs/report', { folder_ids: folderIds, checklist_ids: checklistIds })
  }

  async generateCombinedReport(folderIds: string[], checklistIds: number[]) {
    return this.post('/bulk_jobs/combined_report', { folder_ids: folderIds, checklist_ids: checklistIds })
  }

  // one PDF that sums up the answers of many closed processes (picked ones, or a template in a period)
  async generateSummaryReport(params: {
    folderIds?: string[], checklistIds?: number[], templateId?: number, from?: string | null, to?: string | null, teamIds?: number[]
  }) {
    return this.post('/bulk_jobs/summary_report', {
      folder_ids: params.folderIds,
      checklist_ids: params.checklistIds,
      template_id: params.templateId,
      from: params.from || undefined,
      to: params.to || undefined,
      team_ids: params.teamIds
    })
  }

  async generateExcel(folderIds: string[], checklistIds: number[]) {
    return this.post('/bulk_jobs/excel', { folder_ids: folderIds, checklist_ids: checklistIds })
  }

  async bulkDelete(folderIds: string[], checklistIds: number[], templateIds: number[]) {
    return this.post(
      '/bulk_jobs/delete',
      { folder_ids: folderIds, checklist_ids: checklistIds, template_ids: templateIds }
    )
  }

  async generateCsv(folderIds: string[], checklistIds: number[]) {
    return this.post('/bulk_jobs/csv', { folder_ids: folderIds, checklist_ids: checklistIds })
  }
 

  async move(folderIds: any[], checklistIds: any[], templateIds: any[], targetId: string) {
    return this.post('/bulk_jobs/move', {
      folder_ids: folderIds,
      checklist_ids: checklistIds,
      template_ids: templateIds,
      target_id: targetId
    })
  }
}
